// import React, { useMemo } from 'react';
// import { useTheme } from '../context/ThemeContext';
// import Header from '../components/Header';
// import Hero from '../components/Hero';
// import Services from '../components/Services';
// import Zone from '../components/Zone';
// import WhyChoose from '../components/WhyChoose';
// import Contact from '../components/Contact';
// import Footer from '../components/Footer';

// const Starfield = ({ isDark }) => {
//   const stars = useMemo(() => {
//     const list = [];
//     for (let i = 0; i < 200; i++) {
//       const rand = Math.random();
//       let size;
//       if (rand < 0.5) size = 1;
//       else if (rand < 0.8) size = 1.5;
//       else if (rand < 0.95) size = 2;
//       else size = 2.5;

//       list.push({
//         id: i,
//         left: `${Math.random() * 100}%`,
//         top: `${Math.random() * 100}%`,
//         size,
//         delay: `${Math.random() * 8}s`,
//         duration: `${2 + Math.random() * 5}s`,
//         baseOpacity: 0.15 + Math.random() * 0.35,
//       });
//     }
//     return list;
//   }, []);

//   return (
//     <div
//       className="fixed inset-0 pointer-events-none"
//       style={{ zIndex: 40 }}
//       aria-hidden="true"
//     >
//       {stars.map((star) => (
//         <div
//           key={star.id}
//           className="absolute rounded-full star-twinkle"
//           style={{
//             left: star.left,
//             top: star.top,
//             width: `${star.size}px`,
//             height: `${star.size}px`,
//             animationDelay: star.delay,
//             animationDuration: star.duration,
//             backgroundColor: isDark ? '#D4AF37' : '#B8960C',
//             '--star-opacity': star.baseOpacity,
//             boxShadow: isDark
//               ? `0 0 ${star.size * 2}px rgba(212,175,55,0.4)`
//               : `0 0 ${star.size * 2}px rgba(184,150,12,0.3)`,
//           }}
//         />
//       ))}
//     </div>
//   );
// };

// const HomePage = () => {
//   const { isDark } = useTheme();

//   return (
//     <div className={`relative min-h-screen transition-colors duration-500 ${
//       isDark ? 'bg-[#0D0D0D]' : 'bg-[#FAF7F0]'
//     }`}>
//       <Starfield isDark={isDark} />
//       <Header />
//       <main>
//         <Hero />
//         <Services />
//         <Zone />
//         <WhyChoose />
//         <Contact />
//       </main>
//       <Footer />
//     </div>
//   );
// };

// export default HomePage;


// 

import React, { useMemo } from 'react';
import { useTheme } from '../context/ThemeContext';
import Header from '../components/Header';
import Hero from '../components/Hero';
import Services from '../components/Services';
import Zone from '../components/Zone';
import WhyChoose from '../components/WhyChoose';
import Contact from '../components/Contact';
import Footer from '../components/Footer';
import LaunchBanner from '../components/LaunchBanner';

const Starfield = ({ isDark }) => {
  const stars = useMemo(() => {
    const list = [];
    for (let i = 0; i < 200; i++) {
      const rand = Math.random();
      let size;
      if (rand < 0.5) size = 1;
      else if (rand < 0.8) size = 1.5;
      else if (rand < 0.95) size = 2;
      else size = 2.5;

      list.push({
        id: i,
        left: `${Math.random() * 100}%`,
        top: `${Math.random() * 100}%`,
        size,
        delay: `${Math.random() * 8}s`,
        duration: `${2 + Math.random() * 5}s`,
        baseOpacity: 0.15 + Math.random() * 0.35,
      });
    }
    return list;
  }, []);

  return (
    <div
      className="fixed inset-0 pointer-events-none"
      style={{ zIndex: 40 }}
      aria-hidden="true"
    >
      {stars.map((star) => (
        <div
          key={star.id}
          className="absolute rounded-full star-twinkle"
          style={{
            left: star.left,
            top: star.top,
            width: `${star.size}px`,
            height: `${star.size}px`,
            animationDelay: star.delay,
            animationDuration: star.duration,
            backgroundColor: isDark ? '#D4AF37' : '#B8960C',
            '--star-opacity': star.baseOpacity,
            boxShadow: isDark
              ? `0 0 ${star.size * 2}px rgba(212,175,55,0.4)`
              : `0 0 ${star.size * 2}px rgba(184,150,12,0.3)`,
          }}
        />
      ))}
    </div>
  );
};

const HomePage = () => {
  const { isDark } = useTheme();

  return (
    <div className={`relative min-h-screen transition-colors duration-500 ${
      isDark ? 'bg-[#0D0D0D]' : 'bg-[#FAF7F0]'
    }`}>
      <Starfield isDark={isDark} />
      <Header />
      <LaunchBanner />
      <main>
        <Hero />
        <Services />
        <Zone />
        <WhyChoose />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;